import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Foundation from "./sections/Foundation";
import MakingTheWorldABetterPlace from "./sections/MakingTheWorldABetterPlace";
import Impact from "./sections/Impact";
import FoundationNews from "./sections/FoundationNews";
import Join from "./sections/Join";
import Voices from "./sections/Voices";
import Footer from "@/reusable_sections/Footer";
import Timeline from "./sections/Timeline";
export default function HomePage() {
  return <div>
      <Header />
      <Foundation />
      <MakingTheWorldABetterPlace />
      <Timeline />
      <Impact />
      <FoundationNews />
      <Join />
      <Voices />
      <Footer />
    </div>;
}